/* BuduShop hero: cyclic rotation, editable campaigns and native navigation. */
if (!customElements.get('budu-editorial-launches')) {
 customElements.define('budu-editorial-launches', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController(); const { signal } = this.controller;
   this.tabs = [...this.querySelectorAll('[data-launch-tab]')];
   this.panels = [...this.querySelectorAll('[data-launch-panel]')];
   if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
   this.header = document.getElementById('shopify-section-header');
   this.active = 0; this.visible = true; this.editorSelection = false;
   this.interval = Math.max(5, Number(this.dataset.interval) || 8) * 1000;
   this.classList.add('is-enhanced');
   this.querySelector('[data-launch-nav]').setAttribute('role','tablist');
   this.tabs.forEach((tab,index) => {
    tab.setAttribute('role','tab'); tab.setAttribute('aria-controls',this.panels[index].id);
    this.panels[index].setAttribute('role','tabpanel'); this.panels[index].setAttribute('aria-labelledby',tab.id);
    tab.addEventListener('click', event => { event.preventDefault(); this.select(index); this.schedule(); }, {signal});
    tab.addEventListener('keydown', event => {
     let next=index;
     if(event.key==='ArrowRight') next=(index+1)%this.tabs.length;
     else if(event.key==='ArrowLeft') next=(index-1+this.tabs.length)%this.tabs.length;
     else if(event.key==='Home') next=0;
     else if(event.key==='End') next=this.tabs.length-1;
     else return;
     event.preventDefault(); this.select(next); this.tabs[next].focus(); this.schedule();
    },{signal});
   });
   document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
   this.addEventListener('focusin',()=>this.schedule(),{signal});
   this.addEventListener('focusout',()=>queueMicrotask(()=>this.schedule()),{signal});
   document.addEventListener('shopify:block:select',event=>{
    const index=this.panels.findIndex(panel=>panel===event.target||panel.contains(event.target));
    if(index>=0){this.editorSelection=true;this.select(index);this.schedule();}
   },{signal});
   document.addEventListener('shopify:block:deselect',()=>{this.editorSelection=false;this.schedule();},{signal});
   if(this.header){
    this.header.classList.add('budu-hero-header');
    this.resize=new ResizeObserver(()=>this.style.setProperty('--budu-header-height',this.header.offsetHeight+'px'));
    this.resize.observe(this.header); this.style.setProperty('--budu-header-height',this.header.offsetHeight+'px');
   }
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();});
   this.observer.observe(this.querySelector('[data-launch-stage]'));
   this.select(0);this.schedule();
  }
  select(index){
   this.active=index;
   this.panels.forEach((panel,position)=>{
    const active=position===index;panel.classList.toggle('is-active',active);panel.inert=!active;
    panel.setAttribute('aria-hidden',String(!active));this.tabs[position].setAttribute('aria-selected',String(active));this.tabs[position].tabIndex=active?0:-1;
   });
   const tone=this.panels[index].dataset.tone;this.dataset.tone=tone;if(this.header)this.header.dataset.heroTone=tone;
   const image=this.panels[(index+1)%this.panels.length].querySelector('img');if(image)image.loading='eager';
  }
  schedule(){
   clearTimeout(this.timer);
   if(this.dataset.autoplay!=='true'||this.panels.length<2||!this.visible||document.hidden||this.editorSelection)return;
   // Do not move a slide while its link has keyboard focus; rotation resumes on blur.
   if(this.panels.some(panel=>panel.contains(document.activeElement)))return;
   this.timer=setTimeout(()=>{this.select((this.active+1)%this.panels.length);this.schedule();},this.interval);
  }
  disconnectedCallback(){
   clearTimeout(this.timer);this.controller?.abort();this.controller=null;this.resize?.disconnect();this.observer?.disconnect();
   this.header?.classList.remove('budu-hero-header');if(this.header)delete this.header.dataset.heroTone;
  }
 });
}
/* Close Dawn's mobile drawer when following an on-page editorial link. */
document.addEventListener('click', event => {
  const link = event.target.closest('a[data-budu-menu-anchor]');
  if (!link) return;
  const drawer = link.closest('header-drawer');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event);
});
